export const isDev = () => {
    return import.meta.env.DEV
}

export const isProduction = () => {
    return import.meta.env.PROD
}